import { apiRequest } from "./client";

export type SyncJob = {
  id: number;
  kind: string;
  status: "pending" | "running" | "paused" | "done" | "failed";
  progress_pct: number;
  error: string | null;
  pause_requested: boolean;
  paused_at: string | null;
  started_at: string | null;
  finished_at: string | null;
  created_at: string;
};

export type SyncJobListResponse = { items: SyncJob[] };

export function startInitialSync(tabId: string) {
  return apiRequest<SyncJob>(`/admin/tabs/${tabId}/sync/initial`, { method: "POST" });
}

export function listSyncJobs(tabId: string) {
  return apiRequest<SyncJobListResponse>(`/admin/tabs/${tabId}/sync/jobs`);
}

export function getSyncJob(tabId: string, jobId: number) {
  return apiRequest<SyncJob>(`/admin/tabs/${tabId}/sync/jobs/${jobId}`);
}

export function pauseSyncJob(tabId: string, jobId: number) {
  return apiRequest<SyncJob>(
    `/admin/tabs/${tabId}/sync/jobs/${jobId}/pause`,
    { method: "POST" },
  );
}

export function resumeSyncJob(tabId: string, jobId: number) {
  return apiRequest<SyncJob>(
    `/admin/tabs/${tabId}/sync/jobs/${jobId}/resume`,
    { method: "POST" },
  );
}
